import React from 'react';
import { Modal } from "antd";
import styles from "./EmptyModal.module.scss";
const EmptyModal = (props) => {
    const { visible, children } = props;
    return (React.createElement(Modal, { open: visible, closable: false, footer: null, centered: true },
        React.createElement("div", { className: styles.content }, children)));
};
export default EmptyModal;
